module.exports = __webpack_public_path__ + "static/media/widget2.808affc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/adminPanel/Content Management/assets/widget2.png
// module id = 1416
// module chunks = 1